import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';

interface FixErrorsHeaderProps {
  onCancel: () => void;
}

const FixErrorsHeader = ({ onCancel }: FixErrorsHeaderProps) => {
  return (
    <header className="flex shrink-0 items-center gap-3 border-b border-border bg-card px-6 py-4">
      <Button
        variant="ghost"
        size="icon"
        type="button"
        onClick={onCancel}
        tooltip="Back to import properties"
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <Typography as="h1" variant="heading-lg" className="truncate font-medium">
        Fix Errors &amp; Import
      </Typography>
    </header>
  );
};

export default FixErrorsHeader;
